var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 8.59967V11.3997C10.6666 13.733 9.73331 14.6663 7.39998 14.6663H4.59998C2.26665 14.6663 1.33331 13.733 1.33331 11.3997V8.59967C1.33331 6.26634 2.26665 5.33301 4.59998 5.33301H7.39998C9.73331 5.33301 10.6666 6.26634 10.6666 8.59967Z",
    fill: "#00FF00",
    stroke: "#00FF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4.59967V7.39967C14.6666 9.73301 13.7333 10.6663 11.4 10.6663H10.6666V8.59967C10.6666 6.26634 9.73331 5.33301 7.39998 5.33301H5.33331V4.59967C5.33331 2.26634 6.26665 1.33301 8.59998 1.33301H11.4C13.7333 1.33301 14.6666 2.26634 14.6666 4.59967Z",
    stroke: "#00FF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.da3da39144e841fd5ebdccccbcf2b7c6.svg";
export { ForwardRef as ReactComponent };